// 本地枚举json
import mjJson from '../../static/js/meiju.json'
// 正则
import regular from '../../static/js/validate/regular'
import moment from 'moment'

moment.locale('zh-cn');
/**
 * 展示输入
 * @param cDOM
 * @param row
 * @param key
 * @param inputs
 * @returns
 * {'标题':'输入值'}
 */
export default (cDOM, row, key, inputs) => {
  let value = row[key];
  let item = inputs[key];
  let reg, mj;

  try {
    reg = inputs[key].regular
  } catch (e) {
    reg = undefined
  }
  try {
    mj = inputs[key].mj
  } catch (e) {
    mj = undefined
  }

  let color = '#495060';
  if (!value) {
    value = "未填写";
    color = "#ed4014"
  } else if (reg && !regular[reg].test(value)) {
    value = "格式不正确";
    color = "#ff9900"
  } else if (mj) {
    let list = mjJson[mj];
    for (let i in list) {
      if (value == list[i].code) {
        value = list[i].name;
      }
    }
    if (row[key] === value) {
      value = "请选择正确的格式";
      color = "#ff9900"
    }
  } else if(item.append){
    value += ` (${item.append})`
  } else if(item.type === 'date') {
    let output = 'YYYY年MM月DD日';
    if (item.dateType === 'month') {
      output = 'YYYY年MM月'
    } else if (item.dateType === 'year') {
      output = 'YYYY年'
    }
    value = moment(item.value).format(output)
  }
  // 自定义验证
  // else if (inputs[key].customVerify) {
  //   if (inputs[key].customVerify(row[key]) === false) {
  //     value = "格式不正确";
  //     color = "#ff9900"
  //   }
  // }

  return cDOM('span', {
    style: {
      color
    }
  }, value)
}




// WEBPACK FOOTER //
// ./src/components/s-input/SBatchFormat.js